import React, { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { ToastContainer, toast } from "react-toastify"; // Import toast
import "react-toastify/dist/ReactToastify.css"; // Import CSS for toast notifications

export default function SidebarGalleryManagementPage() {
  const [galleryData, setGalleryData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedSection, setSelectedSection] = useState(null); 
  const [currentImageIndex, setCurrentImageIndex] = useState(0); 

  // Fetch all gallery sections
  useEffect(() => {
    const fetchGallery = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/sidebargallery/all`);
        setGalleryData(response.data);
        setLoading(false);
      } catch (err) {
        console.error(err);
        setError("No  gallery data");
        setLoading(false);
      }
    };
    fetchGallery();
  }, []);

  // Handle opening modal to view images
  const handleImageClick = (section, index) => {
    setSelectedSection(section);
    setCurrentImageIndex(index);
  };

  // Handle closing modal
  const closeModal = () => {
    setSelectedSection(null);
    setCurrentImageIndex(0);
  };

  // Handle next and previous image navigation
  const handleNext = () => {
    if (currentImageIndex < selectedSection.images.length - 1) {
      setCurrentImageIndex(currentImageIndex + 1);
    }
  };

  const handlePrev = () => {
    if (currentImageIndex > 0) {
      setCurrentImageIndex(currentImageIndex - 1);
    }
  };

  if (loading) return <div className="py-8 text-center">Loading...</div>;
  if (error) return <div className="text-center text-red-500">{error}</div>;

  return (
    <motion.div
      className="w-full max-w-md bg-white border-4 border-[#00BFA5] rounded-md shadow-lg p-4"
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.5 }}
    >
      {/* Gallery heading */}
      <h1 className="text-xl font-bold text-blue-900 mb-4">Gallery</h1>
      <div className="space-y-6">
        {/* Gallery sections */}
        <section className="mb-8">
          <div className="space-y-6">
            {galleryData.map((section) => (
              <motion.div
                key={section._id}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.2 }}
                className="p-6 bg-white border rounded-lg shadow-lg"
              >
                {/* Image section name */}
                {/* <h3 className="text-xl font-semibold text-gray-800">
                  {section.sectionName}
                </h3> */}

                {/* Image grid */}
                <div className="grid grid-cols-2 gap-4 mt-4">
                  {section.images.map((image, i) => (
                    <div
                      key={i}
                      className="relative group cursor-pointer"
                      onClick={() => handleImageClick(section, i)} // Open the section in modal on image click
                    >
                      <img
                        src={`https://collegebackend-e43r.onrender.com/uploads/sidegallery/${encodeURIComponent(
                          image
                        )}`}
                        alt={`image ${i}`}
                        className="object-fill w-full"
                      />
                      <div className="absolute inset-0 transition-opacity bg-black bg-opacity-50 opacity-0 group-hover:opacity-100"></div>
                    </div>
                  ))}
                </div>
              </motion.div>
            ))}
          </div>
        </section>

        {/* Toast notifications */}
        <ToastContainer />
      </div>

      {/* Modal for image view */}
      {selectedSection && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="relative bg-white p-6 rounded-lg max-w-3xl w-full">
            <button
              onClick={closeModal}
              className="absolute top-2 right-2 text-2xl font-bold text-gray-700"
            >
              &times;
            </button>

            {/* Navigation arrows in the center of the image */}
            <button
              onClick={handlePrev}
              className="absolute left-0 top-1/2 transform -translate-y-1/2 text-4xl text-gray-700 bg-white p-2 rounded-full"
            >
              &lt;
            </button>
            <button
              onClick={handleNext}
              className="absolute right-0 top-1/2 transform -translate-y-1/2 text-4xl text-gray-700 bg-white p-2 rounded-full"
            >
              &gt;
            </button>

            <div className="relative">
              <img
                src={`/api/uploads/sidegallery/${selectedSection.images[currentImageIndex]}`}
                alt={`image ${currentImageIndex}`}
                className="object-cover w-full h-96 rounded-lg"
              />
            </div>
          </div>
        </div>
      )}
    </motion.div>
  );
}
